import { rootApi } from "../../api/rootApi";

export const borosilApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getRankRules: builder.mutation({
            query: ({
                token,
                tenant_id,
                query = { limit: 9999, offset: 0 },
            }) => {
                return {
                    method: "GET",
                    url: `/tenant/borosil/product-date-rank-rules/?${new URLSearchParams(
                        query
                    )?.toString()}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                        slug: tenant_id,
                    },
                };
            },
        }),
    }),
});

export const { useGetRankRulesMutation } = borosilApi;
